import { useTranslation } from 'react-i18next';
import { X, Loader2, PlusCircle } from 'lucide-react';

export default function AddProgressModal({ open, value, onChange, saving, onClose, onSubmit }) {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-end sm:items-center justify-center z-50 px-4 pt-4 pb-[max(env(safe-area-inset-bottom),1rem)]"
      onClick={() => !saving && onClose()}
    >
      <div
        className="bg-white rounded-3xl w-full max-w-md p-6 border-b-4 border-[#E5E5E5] max-h-[90dvh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
        data-testid="add-progress-modal"
      >
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-xl font-extrabold">{t('c.dashboard.AddProgressModal.add_a_quick_progress_note')}</h3>
          <button onClick={onClose} className="p-1" data-testid="close-add-progress">
            <X size={24} strokeWidth={3} />
          </button>
        </div>
        <p className="text-sm font-bold text-[#4B4B4B] mb-3"> {t('c.dashboard.AddProgressModal.capture_what_you_did_so_far')} </p>
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          rows={4}
          maxLength={500}
          placeholder={t('c.dashboard.AddProgressModal.did_a_10_minute_warm_up')}
          className="gm-input text-base"
          data-testid="add-progress-input"
        />
        <p className="text-right text-xs text-[#AFAFAF] font-extrabold mt-1">{value.length}/500</p>
        <button
          onClick={onSubmit}
          disabled={saving || value.trim().length < 2}
          className="gm-btn gm-btn-primary w-full text-lg py-3 mt-3"
          data-testid="submit-add-progress"
        >
          {saving ? (
            <><Loader2 size={18} strokeWidth={3} className="animate-spin" /> {t('c.dashboard.AddProgressModal.saving')}</>
          ) : (
            <><PlusCircle size={18} strokeWidth={3} /> {t('c.dashboard.AddProgressModal.save_note')}</>
          )}
        </button>
      </div>
    </div>
  );
}
